import { apiObject } from "./apiobject"
import axios from 'axios'

const reports = {
    ...apiObject,
    url: '/reports/',
    getProjectCaseReport (id) {
      return axios.get(`${this.url}pc/${id}/`, {
        responseType: 'arraybuffer'
      })
    },
    getProjectDocumentReport (projectId, documentId) {
      return axios.get(`${this.url}pd/${projectId}/${documentId}/`, {
        responseType: 'arraybuffer'
      })
    },
}

export default {
    reports
}
